$(document).ready(function(){
 var counter = Number($(".wishlist_counter").text());
    $(document).on('click', '.wishlish', function() {
      var keyid = $(this).attr('id');
       var valid = $(this).attr('data-id');
     localStorage.setItem(keyid, valid);
       var wishID = localStorage.getItem(keyid);
      if(wishID == valid){
        $(this).addClass("active");
      }
     counter++;
  
  $(".wishlist_counter").text(counter);
    if (counter < 1) {
        $(".wishlist_counter").hide();
    } else {
        $(".wishlist_counter").show();
    }
    });
   
  $('.wishlish').each(function() {
    var keyid = $(this).attr('id');
    var valid = $(this).attr('data-id');
    let wishfind = localStorage.getItem(keyid);

    if (wishfind == valid) {
      $(this).addClass('active'); 
     
    }
    
  });
 
});


